import { render, staticRenderFns } from "./UpsellConfirmed.vue?vue&type=template&id=a0b0b98c&"
import script from "./UpsellConfirmed.vue?vue&type=script&lang=js&"
export * from "./UpsellConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./UpsellConfirmed.vue?vue&type=style&index=0&id=a0b0b98c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports